import styled, { css } from 'styled-components';

export const SubHeaderFunctionContainer = styled.div`
  width: 100%;
  display: flex;

  & > div {
    flex: 1;
  }
`;

export const SubHeaderFunctionsBar = styled.div`
  display: flex;
  margin-right: 15px;
  margin-bottom: 10px;
`;

export const StatusContainer = styled.div`
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}

  && > i {
    margin-right: 4px;
  }
`;

export const PerformanceContainer = styled.div`
  padding: 4px;
  border-radius: 4px;
  text-align: center;

  && > span {
    color: white;
    text-transform: uppercase;
    font-weight: bold;
  }

  ${({ color }) =>
    color &&
    css`
      background-color: ${color};
    `}
`;
